export const WISHES = {
    BIRTHDAY: [
        "Happy Birthday! May your day be filled with joy and smiles 🎉",
        "Happy Birthday! Wishing you success and good health",
        "Many many happy returns of the day! Have a fantastic year ahead 🎂",
        "Happy Birthday! Keep shining and achieving great things ✨",
        "Warm birthday wishes to you! May all your dreams come true",
        "Cheers to another year of growth and happiness. Happy Birthday 🥳",
        "Happy Birthday! Thank you for being such an amazing part of the team",
        "Sending you lots of good wishes on your special day 🎈",
        "Happy Birthday! Wishing you happiness today and always",
        "May your birthday be as wonderful as you are. Have a great one!"
    ],

    WORK_ANNIVERSARY: [
        "Happy Work Anniversary! Thank you for your hard work 👏",
        "Congratulations on another successful year with us!",
        "Happy Anniversary! Your contributions truly make a difference",
        "Cheers to your work anniversary and many more milestones ahead 🎉",
        "Thank you for being a valued part of our journey. Happy Work Anniversary!",
        "Another year, another achievement. Happy Anniversary!",
        "We appreciate your commitment and passion. Happy Work Anniversary ✨",
        "Congratulations on completing another year of excellence with us!",
        "Happy Work Anniversary! Wishing you continued success and growth",
        "Your hard work inspires us all. Happy Anniversary!"
    ]
};